import { defineFcm } from '../shared/factory';

export const FCM_MEMBERSHIP_PPMU_ENABLED_FOR = defineFcm('membership_ppmu_enabled_for')
	.asBoolean()
	.withDefault(false)
	.toConfig();
